import React from 'react';
import LeftBar from '../../Components/LeftBar';
import Dashnav from '../../Components/Dashnav';
import LabOnboardingComp from './LabOnboardingComp';

function LabOnboarding() {
  return (
    <div className="mainContainer">
      <LeftBar />
      <div className="theMainContainer">
        <Dashnav />
        <LabOnboardingComp />
      </div>
    </div>
  );
}

export default LabOnboarding;
